import type { DocumentChangeType } from "firebase/firestore";
import { z } from "zod";

export enum ConversationType {
	direct = "direct",
}

export enum MessageKind {
	text = "text",
	audio = "audio",
}

export const chatUnreadMessagesSchema = z.object({
	unread_messages: z.number().int().nonnegative(),
});

export const participantSchema = z.object({
	nickname: z.string(),
	photo: z.string(),
	uid: z.string(),
	unread_messages: z.number().nullish(),
});

const audioAttachmentSchema = z.object({
	audio: z.object({ duration: z.number() }),
	filename: z.string(),
	mime_type: z.string(),
	size: z.number(),
	url: z.string(),
	uuid: z.string(),
});

export const messageSchema = z.object({
	text: z.string().nullable(),
	sender_id: z.string(),
	kind: z.nativeEnum(MessageKind),
	created_at: z.number().or(z.string()),
	attachments: z.array(audioAttachmentSchema),
	uuid: z.string(),
	conversation_uuid: z.string().nullish(),
});

export const firestoreMessageSchema = z.object({
	text: z.string().nullable(),
	sender_id: z.string(),
	kind: z.nativeEnum(MessageKind),
	created_at: z.number().or(z.string()),
	attachments: z.array(audioAttachmentSchema),
});

export const conversationSchema = z.object({
	changeType: z.custom<DocumentChangeType>(),
	last_activity_at: z.number(),
	latest_message: firestoreMessageSchema.nullish(),
	participants: z.array(z.string()),
	read_status: z.record(
		z.string(),
		z.object({ message_uuid: z.string().nullish(), read_at: z.number().nullish(), unread_count: z.number() }),
	),
	type: z.nativeEnum(ConversationType),
	uuid: z.string(),
});

export const simpleConversationSchema = z.object({
	uuid: z.string().nullable(),
	name: z.string(),
	participant: participantSchema,
});

export const searchUserSchema = z.object({
	activity: z.number(),
	background: z.string(),
	blocked: z.boolean(),
	created_at: z.string(),
	followed: z.boolean(),
	follows: z.number(),
	nickname: z.string(),
	photo: z.string(),
	private: z.boolean(),
	uid: z.string(),
});
